import React, { useState } from 'react';
import { 
  QrCode, LogOut, HelpCircle, Monitor, ShieldCheck, Activity, Clock 
} from 'lucide-react';

// ✅ IMPORTACIONES CON RUTAS ABSOLUTAS
import ModuloRecepcion from 'pages/recepcion/ModuloRecepcion'; 

const RecepcionModule = ({ alSalir }) => {
  const [tabActiva, setTabActiva] = useState('checkin');

  const menuItems = [
    { id: 'checkin', titulo: 'Terminal de Registro', icono: QrCode, desc: 'Entradas y Salidas' },
    { id: 'ayuda', titulo: 'Asistencia Staff', icono: HelpCircle, desc: 'Soporte y Guía' },
  ];

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col md:flex-row font-sans overflow-hidden text-left">
      
      {/* SIDEBAR DE CONTROL (AZUL PROFUNDO + ÁMBER) */}
      <aside className="hidden md:flex w-80 bg-[#0A2440] flex-col sticky top-0 h-screen shadow-[10px_0_30px_rgba(0,0,0,0.2)] z-50">
        {/* Banner de Identidad */}
        <div className="p-10 bg-amber-500 relative overflow-hidden group">
          <div className="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-2xl group-hover:scale-150 transition-all duration-700" />
          <div className="relative z-10">
            <h1 className="text-4xl font-black text-[#0A2440] italic tracking-tighter leading-none uppercase">IgleKids</h1>
            <p className="text-[10px] font-black text-[#0A2440]/60 uppercase tracking-[0.4em] mt-2">Torre de Recepción</p>
          </div>
        </div>

        {/* Navegación Principal */}
        <nav className="flex-1 px-4 py-12 space-y-4">
          {menuItems.map((item) => {
            const activo = tabActiva === item.id;
            const Icono = item.icono;
            return (
              <button
                key={item.id}
                onClick={() => setTabActiva(item.id)}
                className={`w-full flex items-center gap-5 px-6 py-5 rounded-[2.5rem] transition-all duration-500 group relative ${
                  activo 
                  ? 'bg-white/10 text-white shadow-2xl border border-white/5' 
                  : 'text-slate-500 hover:text-white hover:bg-white/5'
                }`}
              >
                {activo && <div className="absolute left-0 w-2 h-10 bg-amber-500 rounded-r-full shadow-[0_0_15px_#f59e0b]" />}
                
                <div className={`p-3 rounded-2xl transition-all duration-500 ${activo ? 'bg-amber-500 text-[#0A2440] rotate-3' : 'bg-white/5 text-slate-500'}`}>
                  <Icono size={22} strokeWidth={activo ? 3 : 2} />
                </div>
                
                <div className="text-left">
                  <p className="text-xs font-black uppercase tracking-widest">{item.titulo}</p>
                  <p className={`text-[9px] font-bold mt-1 uppercase tracking-tighter ${activo ? 'text-amber-400/80' : 'text-slate-600'}`}>{item.desc}</p>
                </div>
              </button>
            );
          })}
        </nav>

        {/* PANEL DE SALUD DEL SISTEMA */}
        <div className="p-8 space-y-6 border-t border-white/5 bg-black/20 backdrop-blur-md">
          <div className="space-y-3">
             <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse shadow-[0_0_12px_#10b981]" />
                <span className="text-[10px] font-black text-emerald-500 uppercase tracking-[0.2em]">En Línea</span>
             </div>
             <div className="flex items-center gap-3">
                <Activity size={14} className="text-slate-600" />
                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest italic">Sync: 0.04s</span>
             </div>
          </div>

          <button 
            onClick={alSalir}
            className="w-full py-5 rounded-[1.8rem] bg-rose-500/10 text-rose-500 hover:bg-rose-600 hover:text-white transition-all font-black text-[10px] uppercase tracking-[0.3em] border-2 border-rose-500/20 active:scale-95 shadow-xl"
          >
            Finalizar Turno
          </button>
        </div>
      </aside>

      {/* HEADER MÓVIL (VISIBLE EN TABLETS) */}
      <header className="md:hidden bg-[#0A2440] px-6 py-5 flex items-center justify-between shadow-2xl sticky top-0 z-50 border-b-4 border-amber-500">
        <div className="flex items-center gap-4">
          <div className="bg-amber-500 p-2.5 rounded-[1.2rem] shadow-lg shadow-amber-500/20">
             <ShieldCheck size={22} className="text-[#0A2440]" />
          </div>
          <div className="flex flex-col">
            <h1 className="text-2xl font-black text-white italic tracking-tighter leading-none uppercase">IgleKids</h1>
            <span className="text-[9px] font-black uppercase tracking-[0.3em] text-amber-400/80">Staff Recepción</span>
          </div>
        </div>
        <button onClick={alSalir} className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center text-rose-400 active:scale-90 transition-all border border-white/10">
          <LogOut size={24} />
        </button>
      </header>

      {/* ÁREA DE OPERACIÓN PRINCIPAL */}
      <main className="flex-1 w-full max-w-[1500px] mx-auto p-6 md:p-14 lg:p-20 overflow-y-auto hide-scrollbar">
        
        {tabActiva === 'checkin' && (
          <div className="animate-in fade-in slide-in-from-bottom-10 duration-700">
            {/* Header de la terminal */}
            <div className="mb-14 hidden md:flex items-end justify-between border-b-4 border-slate-100 pb-10">
              <div className="space-y-2 text-left">
                <div className="flex items-center gap-2 text-indigo-600">
                  <Clock size={16} />
                  <span className="text-[10px] font-black uppercase tracking-[0.4em] italic">Estación de Flujo v3.0</span>
                </div>
                <p className="text-6xl font-black text-[#0A2440] italic tracking-tighter leading-none uppercase">Registro <span className="text-slate-300 font-extralight italic">&</span> Control</p>
              </div>
              <div className="text-right bg-white p-6 rounded-[2.5rem] shadow-xl border border-slate-50">
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em] mb-1">Día de Servicio</p>
                <p className="text-xl font-black text-slate-900 uppercase tracking-tighter italic">
                  {new Date().toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })}
                </p>
              </div>
            </div>
            
            {/* Módulo operativo */}
            <ModuloRecepcion />
          </div>
        )}

        {tabActiva === 'ayuda' && (
          <div className="max-w-4xl mx-auto py-24 text-center space-y-14 animate-in zoom-in-95 duration-500">
            <div className="relative inline-block">
                <div className="absolute inset-0 bg-amber-500 blur-[80px] opacity-20 animate-pulse" />
                <div className="w-40 h-40 bg-white rounded-[4rem] shadow-2xl flex items-center justify-center mx-auto text-amber-500 relative z-10 border-4 border-slate-50">
                  <HelpCircle size={80} strokeWidth={1} />
                </div>
            </div>
            
            <div className="space-y-6">
              <h3 className="text-5xl font-black text-[#0A2440] italic tracking-tight uppercase leading-none">Centro de Soporte</h3>
              <p className="text-slate-500 text-xl font-medium leading-relaxed max-w-2xl mx-auto italic">
                ¿Problemas técnicos? El monitor de pasillo y las impresoras deben estar conectadas a la red <span className="text-indigo-600 font-black">"CASA_DE_FE_ADMIN"</span>.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
               <div className="bg-white p-10 rounded-[3.5rem] border-2 border-slate-50 shadow-sm hover:shadow-xl transition-all group">
                  <div className="w-14 h-14 bg-indigo-50 rounded-2xl flex items-center justify-center text-indigo-600 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all">
                    <Monitor size={32} />
                  </div>
                  <p className="font-black text-slate-900 uppercase text-sm tracking-widest mb-4 italic">Monitor Pasillo</p>
                  <p className="text-slate-500 leading-relaxed font-bold uppercase text-[10px] tracking-widest opacity-70">Si el nombre del niño no aparece al dar entrada, refresca la ventana del monitor en la TV.</p>
               </div>
               <div className="bg-white p-10 rounded-[3.5rem] border-2 border-slate-50 shadow-sm hover:shadow-xl transition-all group">
                  <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center text-emerald-600 mb-6 group-hover:bg-emerald-600 group-hover:text-white transition-all">
                    <Activity size={32} />
                  </div>
                  <p className="font-black text-slate-900 uppercase text-sm tracking-widest mb-4 italic">Seguridad de Datos</p>
                  <p className="text-slate-500 leading-relaxed font-bold uppercase text-[10px] tracking-widest opacity-70">Toda la información se cifra de extremo a extremo. Los registros son permanentes.</p>
               </div>
            </div>
          </div>
        )}
      </main>

      {/* NAVBAR INFERIOR (ESTILO IOS) */}
      <nav className="md:hidden fixed bottom-0 w-full bg-white/90 backdrop-blur-2xl border-t-4 border-slate-100 pb-8 z-50 shadow-[0_-15px_50px_rgba(0,0,0,0.1)]">
        <div className="flex justify-around items-center py-5">
          {menuItems.map((item) => {
            const activo = tabActiva === item.id;
            const Icono = item.icono;
            return (
              <button 
                key={item.id} 
                onClick={() => setTabActiva(item.id)} 
                className={`flex flex-col items-center gap-2 transition-all duration-500 ${activo ? 'text-[#0A2440] scale-110' : 'text-slate-300'}`}
              >
                <div className={`p-4 rounded-[1.8rem] transition-all duration-500 ${activo ? 'bg-amber-500 shadow-2xl shadow-amber-500/40 rotate-6' : 'bg-slate-50'}`}>
                  <Icono size={28} strokeWidth={activo ? 3 : 2} />
                </div>
                <span className="text-[10px] font-black uppercase tracking-[0.2em]">{item.titulo.split(' ')[0]}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default RecepcionModule;